import Api from './ApiWAService'

// Catálogo de produtos do WhatsApp (Meta Commerce) — CRUD direto na Meta
export default {
    /** Lista produtos; `after` é o cursor de paginação da Meta */
    listProducts(after = null) {
        return Api().get(`whatsapp_catalog/products${after ? `?after=${encodeURIComponent(after)}` : ''}`);
    },
    createProduct(data) {
        return Api().post(`whatsapp_catalog/products`, data);
    },
    updateProduct(id, data) {
        return Api().put(`whatsapp_catalog/products/${id}`, data);
    },
    deleteProduct(id) {
        return Api().delete(`whatsapp_catalog/products/${id}`);
    },
    /** Define/limpa o ID do catálogo (override manual do Commerce Manager) */
    saveConfig(catalogId) {
        return Api().put(`whatsapp_catalog/config`, { catalog_id: catalogId });
    },
}
